import React from 'react';
import {Stack, Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {useAppointmentNotifications} from 'presentation/pages/private/hooks';
import {AppointmentsDXProps} from './types';

const {appointmentsNotifications} = translations['pt-br'].privateFlow.home;

export function AppointmentsDX({appointment}: AppointmentsDXProps) {
	const {formattedBeneficiary, daysFromAppointmentDate, isExam, isSurgery} =
		useAppointmentNotifications({
			appointment,
		});
	const isMoreThanOneDay = daysFromAppointmentDate > 1;
	const formattedDaysLeft = isMoreThanOneDay
		? appointmentsNotifications.daysLeft
		: appointmentsNotifications.dayLeft;
	const formattedDays = isMoreThanOneDay
		? appointmentsNotifications.days
		: appointmentsNotifications.day;

	const customPart3 = () => {
		if (isExam) {
			return appointmentsNotifications.forYourExamAppointment;
		}
		if (isSurgery) {
			return appointmentsNotifications.forYourNextSurgeryAppointment;
		}
		return appointmentsNotifications.forYourNextAppointment;
	};

	const part1 = `${formattedBeneficiary}, ${formattedDaysLeft} `;
	const part2 = `${daysFromAppointmentDate} ${formattedDays} `;
	const part3 = customPart3();

	return (
		<Stack spacing={1}>
			<Typography>
				{part1}
				<Typography component="strong" fontWeight={700}>
					{part2}
				</Typography>
				{part3}
			</Typography>
		</Stack>
	);
}
